module.exports = __webpack_public_path__ + "img/big-ball-purple.c3fbf3de.svg";